import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import Request from "../Utils/Request/Request";
import { showToast } from "../Utils/index";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

function UserModal({ close, open, user, setForceUpdate, duplicate, setDuplicate }) {
  const { t } = useTranslation();
  const normaliseImportConfig = (value) => {
    if (typeof value === "string") {
      try {
        value = JSON.parse(value);
      } catch {
        value = null;
      }
    }
    return {
      userIds: Array.isArray(value?.userIds) ? value.userIds : [],
      clients: Boolean(value?.clients),
      products: Boolean(value?.products),
    };
  };
  
  const initialState = {
    fullName: "",
    email: "",
    password: "",
    companyName: "",
    companyNameAR: "",
    companyNumber: null,
    vat: "",
    vatNumber: null,
    invoiceType: "",
    offerType: "",
    address: "",
    buildingNumber: "",
    district: "",
    cityName: "",
    postalZone: "",
    phoneNumber: null,
    invoiceNumberEdit: false,
    allowTax: false,
    allowTotal: false,
    addField: false,
    addDiscount: true,
    username: "",
    isActive: true,
    logo: null,
    showInvoice: null,
    createInvoice: null,
    offerPrice: null,
    purchaseSupplierAccess: null,
    showTotalCalculator: null,
    notifyText: "",
    allowAddValues:false,
    allowTitlesEdit:false,
    allowInvoiceProductExtra:false,
    zatca_phase: 1,
    import_config: { userIds: [], clients: false, products: false },
  };
  const [canEdit, setCanEdit] = useState(false);
  const [allowTax, setAllowTax] = useState(false);
  const [allowTotal, setAllowTotal] = useState(false);
  const [allowTitlesEdit, setAllowTitlesEdit] = useState(false);
  const [allowInvoiceProductExtra, setAllowInvoiceProductExtra] = useState(false);
  const [addFields, setAddFields] = useState(false);
  const [allowAddValues, setAllowAddValues] = useState(false);
  const [addDiscounts, setAddDiscounts] = useState(true);
  const [checked, setChecked] = useState(true);
  const [formData, setFormData] = useState(initialState);
  const [validated, setValidated] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [importConfig, setImportConfig] = useState({ userIds: [], clients: false, products: false });
  const [importUsers, setImportUsers] = useState([]);
  const [selectedImportUsers, setSelectedImportUsers] = useState([]);
  const [importPage, setImportPage] = useState(1);
  const [importSearch, setImportSearch] = useState("");
  const [importHasMore, setImportHasMore] = useState(true);
  const importRequestId = useRef(0);

  const handleEditChange = (event) => {
    let dupObj = { ...formData };
    dupObj.invoiceNumberEdit = event.target.checked;
    setCanEdit(event.target.checked);
    setFormData(dupObj);
  };
  const handleAddField = (event) => {
    let dupObj = { ...formData };
    dupObj.addField = event.target.checked;
    setAddFields(event.target.checked);
    setFormData(dupObj);
  };
  const handleAllowAddValues = (event) => {
    let dupObj = { ...formData };
    dupObj.allowAddValues = event.target.checked;
    setAllowAddValues(event.target.checked);
    setFormData(dupObj);
  };
  const handleAddDiscounts = (event) => {
    let dupObj = { ...formData };
    dupObj.addDiscount = event.target.checked;
    setAddDiscounts(event.target.checked);
    setFormData(dupObj);
  };
  const handleChange = (event) => {
    let dupObj = { ...formData };
    dupObj.isActive = event.target.checked;
    setChecked(event.target.checked);
    setFormData(dupObj);
  };
  const handleAllowTax = (event) => {
    let dupObj = { ...formData };
    dupObj.allowTax = event.target.checked;
    setAllowTax(event.target.checked);
    setFormData(dupObj);
  };
  const handleAllowTotal = (event) => {
    let dupObj = { ...formData };
    dupObj.allowTotal = event.target.checked;
    setAllowTotal(event.target.checked);
    setFormData(dupObj);
  };
  const handleAllowTitlesEdit = (event) => {
    let dupObj = { ...formData };
    dupObj.allowTitlesEdit = event.target.checked;
    setAllowTitlesEdit(event.target.checked);
    setFormData(dupObj);
  };
  const handleAllowInvoiceProductExtra = (event) => {
    let dupObj = { ...formData };
    dupObj.allowInvoiceProductExtra = event.target.checked;
    setAllowInvoiceProductExtra(event.target.checked);
    setFormData(dupObj);
  };
  useEffect(() => {
    if (user) {
      let dupObj = { ...formData };
      dupObj.fullName =  user["fullName"];
      dupObj.email = duplicate ===  true ? "" : user["email"];
      dupObj.vatNumber = user["vatNumber"];
      dupObj.companyName = user["companyName"];
      dupObj.companyNameAR = user["companyNameAR"];
      dupObj.companyNumber = user["companyNumber"];
      dupObj.username = duplicate ===  true ? "" : user["username"];
      dupObj.password = duplicate ===  true ? "" : user["password"];
      dupObj.phoneNumber = user["phoneNumber"];
      dupObj.buildingNumber = user["buildingNumber"] || "";
      dupObj.district = user["district"] || "";
      dupObj.cityName = user["cityName"] || "";
      dupObj.postalZone = user["postalZone"] || "";
      dupObj.notifyText = user["notifyText"];
      dupObj.address = user["address"];
      if (user["showInvoice"] !== null) {
        dupObj.showInvoice = dayjs(user["showInvoice"]);
      }
      if (user["createInvoice"] !== null) {
        dupObj.createInvoice = dayjs(user["createInvoice"]);
      }
      if (user["offerPrice"] !== null) {
        dupObj.offerPrice = dayjs(user["offerPrice"]);
      }
      if (user["purchaseSupplierAccess"] !== null) {
        dupObj.purchaseSupplierAccess = dayjs(user["purchaseSupplierAccess"]);
      }
      
      if (user["showTotalCalculator"] !== null) {
        dupObj.showTotalCalculator = dayjs(user["showTotalCalculator"]);
      }
      dupObj.isActive = user["isActive"];
      dupObj.invoiceType = user["invoiceType"];
      dupObj.offerType = user["offerType"];
      dupObj.vat = user["vat"];
      dupObj.logo = user["logo"];
      dupObj.invoiceNumberEdit = user["invoiceNumberEdit"];
      dupObj.addDiscount = user["addDiscount"];
      dupObj.addField = user["addField"];
      dupObj.allowAddValues = user["allowAddValues"];
      dupObj.allowTax = user["allowTax"];
      dupObj.allowTitlesEdit = user["allowTitlesEdit"];
      dupObj.allowInvoiceProductExtra = user["allowInvoiceProductExtra"];
      dupObj.allowTotal = user["allowTotal"];
      dupObj.zatca_phase = Number(user["zatca_phase"] || 1);
      dupObj.import_config = normaliseImportConfig(user["import_config"]);
      setFormData(dupObj);
      setImportConfig(normaliseImportConfig(user["import_config"]));
      setSelectedImportUsers(user["import_users"] || []);
      setChecked(user["isActive"]);
      setCanEdit(user["invoiceNumberEdit"]);
      setAddDiscounts(user["addDiscount"]);
      setAddFields(user["addField"]);
      setAllowAddValues(user["allowAddValues"]);
      setAllowTax(user["allowTax"]);
      setAllowTotal(user["allowTotal"]);
      setAllowTitlesEdit(user["allowTitlesEdit"]);
      setAllowInvoiceProductExtra(user["allowInvoiceProductExtra"]);
    }
  }, []);

  const loadImportUsers = (page = 1, search = "") => {
    const requestId = ++importRequestId.current;
    Request.get(`/getAllUsers/${page}`, {
      searchPhrase: search,
      sortBy: "username",
      sortOrder: "ASC",
    })
      .then(({ data }) => {
        if (requestId !== importRequestId.current) return;
        const rows = (data.data || []).filter((candidate) => candidate.id !== user?.id);
        setImportUsers((current) => page === 1 ? rows : [...current, ...rows.filter((row) => !current.some((item) => item.id === row.id))]);
        setSelectedImportUsers((current) => current.length
          ? current
          : rows.filter((candidate) => normaliseImportConfig(user?.import_config).userIds.includes(candidate.id)));
        setImportHasMore(page * 12 < Number(data.totalCount || 0));
      })
      .catch(() => showToast("error", "Unable to load users."));
  };

  const loadSelectedImportUsers = (ids) => {
    if (!ids.length) {
      setSelectedImportUsers([]);
      return;
    }
    Request.get("/getAllUsers/1", { ids: ids.join(","), sortBy: "username", sortOrder: "ASC" })
      .then(({ data }) => setSelectedImportUsers(data.data || []))
      .catch(() => showToast("error", "Unable to load selected users."));
  };

  useEffect(() => { loadImportUsers(1, ""); }, []);
  useEffect(() => {
    if (!user?.import_users?.length) {
      loadSelectedImportUsers(normaliseImportConfig(user?.import_config).userIds);
    }
  }, [user]);

  const onFileChange = (e) => {
    if (e.target && e.target.files[0]) {
      let dupObj = { ...formData };
      dupObj.logo = e.target.files[0];
      setFormData(dupObj);
    }
  };

  const validateFormData = () => {
    const vatNumberPattern = /^3.{13}3$/;
    if (
      formData.fullName === "" ||
      formData.password === "" ||
      formData.logo === null ||
      formData.vat === "" ||
      formData.vat === null ||
      formData.companyName === "" ||
      formData.companyNameAR === "" ||
      formData.companyNumber === null ||
      formData.vatNumber === null ||
      !formData.buildingNumber ||
      !/^\d{4}$/.test(formData.buildingNumber) ||
      !formData.postalZone ||
      !/^\d{5}$/.test(formData.postalZone) ||
      !formData.district ||
      !formData.cityName ||
      // formData.showInvoice === "" ||
      // formData.showInvoice === null ||
      // formData.createInvoice === "" ||
      // formData.createInvoice === null ||
      // formData.offerPrice === "" ||
      // formData.offerPrice === null ||
      // formData.purchaseSupplierAccess === "" ||
      // formData.purchaseSupplierAccess === null ||
      // formData.showTotalCalculator === "" ||
      // formData.showTotalCalculator === null ||
      vatNumberPattern.test(formData.vatNumber) === false ||
      formData.address === "" ||
      formData.username === "" ||
      formData.invoiceType === "" ||
      formData.offerType === "" ||
      formData.email === "" ||
      !formData.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
    ) {
      setValidated(false);
      return false;
    }
    setValidated(true);
    return true;
  };

  const handleSubmit = () => {
    if (validateFormData()) {
      let tempData = new FormData();
      tempData.append("fullName", formData.fullName);
      tempData.append("email", formData.email);
      tempData.append("password", formData.password);
      tempData.append("companyName", formData.companyName);
      tempData.append("companyNameAR", formData.companyNameAR);
      tempData.append("companyNumber", formData.companyNumber);
      tempData.append("vat", formData.vat);
      tempData.append("vatNumber", formData.vatNumber);
      tempData.append("notifyText", formData.notifyText);
      let showInvoiceDate;
      if (formData.showInvoice) {
        showInvoiceDate = new Date(formData.showInvoice);
      } else {
        showInvoiceDate = new Date('2099-12-12');
      }
      showInvoiceDate.setUTCHours(0, 0, 0, 0);
      tempData.append("showInvoice", showInvoiceDate);
      
      let createInvoiceDate;
      if (formData.createInvoice) {
        createInvoiceDate = new Date(formData.createInvoice);
      } else {
        createInvoiceDate = new Date('2099-12-12');
      }
      createInvoiceDate.setUTCHours(0, 0, 0, 0);
      tempData.append("createInvoice", createInvoiceDate);
      
      let offerPriceDate 
      if (formData.offerPrice) {
        offerPriceDate = new Date(formData.offerPrice);
      } else {
        offerPriceDate = new Date('2099-12-12');
      }
      offerPriceDate.setUTCHours(0, 0, 0, 0);
      tempData.append("offerPrice", offerPriceDate);
      
      let purchaseSupplierAccessDate; 
      if (formData.purchaseSupplierAccess) {
        purchaseSupplierAccessDate = new Date(formData.purchaseSupplierAccess);
      } else {
        purchaseSupplierAccessDate = new Date('2099-12-12');
      }
      purchaseSupplierAccessDate.setUTCHours(0, 0, 0, 0);
      tempData.append("purchaseSupplierAccess", purchaseSupplierAccessDate);
      
      let showTotalCalculatorDate;
      if (formData.showTotalCalculator) {
        showTotalCalculatorDate = new Date(formData.showTotalCalculator);
      } else {
        showTotalCalculatorDate = new Date('2099-12-12');
      }
      showTotalCalculatorDate.setUTCHours(0, 0, 0, 0);
      tempData.append("showTotalCalculator", showTotalCalculatorDate);


      tempData.append("address", formData.address);
      tempData.append("buildingNumber", formData.buildingNumber);
      tempData.append("district", formData.district);
      tempData.append("cityName", formData.cityName);
      tempData.append("postalZone", formData.postalZone);
      tempData.append("username", formData.username);
      tempData.append("phoneNumber", formData.phoneNumber);
      tempData.append("invoiceType", formData.invoiceType);
      tempData.append("offerType", formData.offerType);
      tempData.append("isActive", formData.isActive);
      tempData.append("addField", formData.addField);
      tempData.append("allowAddValues", formData.allowAddValues);
      tempData.append("addDiscount", formData.addDiscount);
      tempData.append("allowTax", formData.allowTax);
      tempData.append("allowTitlesEdit", formData.allowTitlesEdit);
      tempData.append("allowInvoiceProductExtra", formData.allowInvoiceProductExtra);
      tempData.append("import_config", JSON.stringify(importConfig));
      tempData.append("allowTotal", formData.allowTotal);
      tempData.append("invoiceNumberEdit", formData.invoiceNumberEdit);
      if (user === null || duplicate === true) {
        tempData.append("zatca_phase", formData.zatca_phase);
      }

      if (formData.logo) {
        tempData.append("logo", formData.logo);
      }

      if (user == null || duplicate === true) {
        Request.post("/createUser", tempData, {
          "Content-Type": "multipart/form-data",
        })
          .then((result) => {
            showToast("success", "New User Added");
            setFormData(initialState);
            close();
            setForceUpdate(true);
            console.log("Data: ", result.data);
          })
          .catch((err) => {
            if (err.response.status == 400) {
              showToast("error", err.response.data.message);
            } 
            else if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else {
              showToast("error", "Something went wrong.");
            }
          });
      } else {
        tempData.append("id", user["id"]);
        Request.put("/updateUser", tempData, {
          "Content-Type": "multipart/form-data",
        })
          .then((result) => {
            console.log("Data: ", result.data);
            showToast("success", "User Updated");
            setFormData(initialState);
            close();
            setForceUpdate(true);
          })
          .catch((err) => {
            console.log("Error: ", err);
            if (err.response.status == 401) {
              showToast("error", "Unauthorized user.");
            } else {
              showToast("error", "Something went wrong.");
            }
          });
      }
    }
  };

  useEffect(() => {
    if (user === null) {
      generatePassword();
    }
  }, [open]);

  const generatePassword = () => {
    let pass = "";
    let string =
      "ABCDEFGHIJKLMNOPQRSTUVWXUZ" + "abcdefghijklmnopqrstuvwxyz123456789@#$";
    for (let i = 1; i <= 16; i++) {
      let char = Math.floor(Math.random() * string.length + 1);

      pass += string.charAt(char);
    }
    let dupObj = { ...formData };
    dupObj.password = pass;
    setFormData(dupObj);
  };
  // template names
  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await Request.get('/getAllTemplates');
        setTemplates(response.data);
      } catch (error) {
        console.error('Error fetching templates: ', error);
      }
    };

    fetchTemplates();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={close}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px", // Set your width here
          },
        },
      }}
    >
      <DialogTitle>
        {user === null || duplicate === true ? "Add New User" : "Update User"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          <Grid item xs="auto">
            <TextField
              label="Full Name"
              size="small"
              value={formData.fullName}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.fullName = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.fullName === null || formData.fullName === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Name is required
                </div>
              )}
          </Grid>
          <Grid item>
            <TextField
              label="Email"
              size="small"
              value={formData.email}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.email = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              !formData.email.match(
                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
              ) && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Invalid email
                </div>
              )}
          </Grid>

          {(user === null || duplicate === true) && (
            <Grid item>
              <TextField
                label="Password"
                size="small"
                type={"text"}
                value={formData.password}
                onChange={(e) => {
                  let dupObj = { ...formData };
                  dupObj.password = e.target.value;
                  setFormData(dupObj);
                }}
                sx={{
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                  width: "200px",
                }}
              />
              {!validated &&
                (formData.password === null || formData.password === "") && (
                  <div style={{ color: "red", fontSize: "small" }}>
                    Password is required
                  </div>
                )}
            </Grid>
          )}
          <Grid item>
            <TextField
              label="Company Name (EN)"
              size="small"
              value={formData.companyName}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.companyName = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.companyName === null ||
                formData.companyName === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Company name is required
                </div>
              )}
          </Grid>

          <Grid item>
            <TextField
              label="Company Name (AR)"
              size="small"
              value={formData.companyNameAR}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.companyNameAR = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.companyNameAR === null ||
                formData.companyNameAR === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Company name is required
                </div>
              )}
          </Grid>

          <Grid item>
            <TextField
              type={"number"}
              size="small"
              label="Company Number"
              value={formData.companyNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.companyNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.companyNumber === null ||
                formData.companyNumber === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Company number is required
                </div>
              )}
          </Grid>
          <Grid item>
            <TextField
              type={"number"}
              label="Vat Number"
              size="small"
              value={formData.vatNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.vatNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.vatNumber === null || formData.vatNumber === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Vat number is required
                </div>
              )}
            {!validated && /^3.{13}3$/.test(formData.vatNumber) === false && (
              <div style={{ color: "red" }}>
                TRN must consist of 15 digits, where the first and <br /> last
                digits are [3]
              </div>
            )}
          </Grid>
          <Grid item>
            <TextField
              type={"number"}
              label="Vat %"
              size="small"
              value={formData.vat}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.vat = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated && (formData.vat === null || formData.vat === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Vat Percent is required
              </div>
            )}
          </Grid>
          <Grid item>
            <TextField
              label="Username"
              size="small"
              value={formData.username}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.username = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.username === null || formData.username === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  User name is required
                </div>
              )}
          </Grid>

          <Grid item>
            <TextField
              label="Address"
              size="small"
              value={formData.address}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.address = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated &&
              (formData.address === null || formData.address === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Address is required
                </div>
              )}
          </Grid>

          <Grid item>
            <TextField
              label="Building Number"
              size="small"
              value={formData.buildingNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.buildingNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": { "& span": { color: "#41c1ba !important" } },
                },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
                width: "200px",
              }}
            />
            {!validated && (!formData.buildingNumber || !/^\d{4}$/.test(formData.buildingNumber)) && (
              <div style={{ color: "red", fontSize: "small" }}>Must be 4 digits</div>
            )}
          </Grid>
          <Grid item>
            <TextField
              label="District"
              size="small"
              value={formData.district}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.district = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": { "& span": { color: "#41c1ba !important" } },
                },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
                width: "200px",
              }}
            />
            {!validated && (!formData.district || formData.district === "") && (
              <div style={{ color: "red", fontSize: "small" }}>Required</div>
            )}
          </Grid>
          <Grid item>
            <TextField
              label="City Name"
              size="small"
              value={formData.cityName}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.cityName = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": { "& span": { color: "#41c1ba !important" } },
                },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
                width: "200px",
              }}
            />
            {!validated && (!formData.cityName || formData.cityName === "") && (
              <div style={{ color: "red", fontSize: "small" }}>Required</div>
            )}
          </Grid>
          <Grid item>
            <TextField
              label="Postal Zone"
              size="small"
              value={formData.postalZone}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.postalZone = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": { "& span": { color: "#41c1ba !important" } },
                },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
                width: "200px",
              }}
            />
            {!validated && (!formData.postalZone || !/^\d{5}$/.test(formData.postalZone)) && (
              <div style={{ color: "red", fontSize: "small" }}>Must be 5 digits</div>
            )}
          </Grid>

          <Grid item>
            <TextField
              size="small"
              type={"number"}
              label="Phone Number"
              value={formData.phoneNumber}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.phoneNumber = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
          </Grid>

          <Grid item>
            <FormControl size="small">
              <InputLabel
                sx={{ "&.MuiInputLabel-shrink, &.Mui-focused": { color: "#41c1ba" } }}
                id="demo-simple-select-label"
              >
                Default Invoice Template
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                size="small"
                sx={{
                  width: "200px",
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
                label="Default Invoice Template"
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.invoiceType = e.target.value;
                  setFormData(dupObj);
                }}
                value={formData.invoiceType}
              >
                <MenuItem value={"simple"}>Simple</MenuItem>
                <MenuItem value={"normal"}>Normal</MenuItem>
                <MenuItem value={"normal1"}>Normal 1</MenuItem>
                {templates.map((template) => (
              <MenuItem key={template.id} value={template.name}>
                {template.name}{template.templateType === "designer" ? " (Template Designer)" : ""}
              </MenuItem>
            ))}
              </Select>
            </FormControl>
            {!validated &&
              (formData.invoiceType === null ||
                formData.invoiceType === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Select a Default Invoice Template
                </div>
              )}
          </Grid>
          <Grid item>
            <FormControl size="small">
              <InputLabel
                sx={{ "&.MuiInputLabel-shrink, &.Mui-focused": { color: "#41c1ba" } }}
                id="demo-simple-select-label"
              >
                Default Price Offer Template
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                size="small"
                sx={{
                  width: "200px",
                  "& .MuiInputLabel-shrink": {
                    color: "#41c1ba !important",
                  },
                  "& fieldset": {
                    borderColor: "#41c1ba !important",
                    "& legend": {
                      "& span": {
                        color: "#41c1ba !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#41c1ba",
                  },
                }}
                label="Default Price Offer Template"
                onChange={(e) => {
                  const dupObj = { ...formData };
                  dupObj.offerType = e.target.value;
                  setFormData(dupObj);
                }}
                value={formData.offerType}
              >
                <MenuItem value={"normal"}>Normal</MenuItem>
                {templates.map((template) => (
              <MenuItem key={template.id} value={template.name}>
                {template.name}{template.templateType === "designer" ? " (Template Designer)" : ""}
              </MenuItem>
            ))}
              </Select>
            </FormControl>
            {!validated &&
              (formData.offerType === null ||
                formData.offerType === "") && (
                <div style={{ color: "red", fontSize: "small" }}>
                  Select Offer Type
                </div>
              )}
          </Grid>
          <Grid item>
            <TextField
              type={"file"}
              size="small"
              onChange={onFileChange}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
            {!validated && (formData.logo === null || formData.logo === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Company logo is required
              </div>
            )}
          </Grid>
          
          <Grid item>
            <TextField
              label="NotifyText"
              size="small"
              value={formData.notifyText}
              onChange={(e) => {
                let dupObj = { ...formData };
                dupObj.notifyText = e.target.value;
                setFormData(dupObj);
              }}
              sx={{
                "& .MuiInputLabel-shrink": {
                  color: "#41c1ba !important",
                },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": {
                    "& span": {
                      color: "#41c1ba !important",
                    },
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#41c1ba",
                },
                width: "200px",
              }}
            />
          </Grid>
          <Grid item>
            <Switch
              value={formData.isActive}
              checked={checked}
              onChange={handleChange}
            />
            Active
          </Grid>
          <Grid item>
            <Switch
              value={formData.invoiceNumberEdit}
              checked={canEdit}
              onChange={handleEditChange}
            />
            Invoice Number
          </Grid>
          <Grid item>
            <Switch
              value={formData.addField}
              checked={addFields}
              onChange={handleAddField}
            />
            Add Fields
          </Grid>
          <Grid item>
            <Switch
              value={formData.allowAddValues}
              checked={allowAddValues}
              onChange={handleAllowAddValues}
            />
           Allow Add Values
          </Grid>
          <Grid item>
            <Switch
              value={formData.addDiscount}
              checked={addDiscounts}
              onChange={handleAddDiscounts}
            />
            Allow Discounts
          </Grid>
          <Grid item>
            <Switch
              value={formData.allowTax}
              checked={allowTax}
              onChange={handleAllowTax}
            />
            Allow Tax
          </Grid>
          <Grid item>
            <Switch
              value={formData.allowTotal}
              checked={allowTotal}
              onChange={handleAllowTotal}
            />
            Allow Total
          </Grid>
          <Grid item>
            <Switch
              value={formData.allowTitlesEdit}
              checked={allowTitlesEdit}
              onChange={handleAllowTitlesEdit}
            />
            Edit Product Titles
          </Grid>
          <Grid item>
            <Switch
              value={formData.allowInvoiceProductExtra}
              checked={allowInvoiceProductExtra}
              onChange={handleAllowInvoiceProductExtra}
            />
            Allow Product Extra Values
          </Grid>
          <Grid item xs={12} style={{ marginTop: "8px" }}>
            <h4 style={{ textAlign: "center", margin: "unset" }}>Import Data</h4>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "-8px" }}>
            <FormControlLabel control={<Checkbox checked={importConfig.clients} onChange={(event) => setImportConfig((value) => ({ ...value, clients: event.target.checked }))} />} label="Clients" />
            <FormControlLabel control={<Checkbox checked={importConfig.products} onChange={(event) => setImportConfig((value) => ({ ...value, products: event.target.checked }))} />} label="Products" />
            {(importConfig.clients || importConfig.products) && (
              <Autocomplete
                style={{ marginTop: "8px" }}
                multiple filterOptions={(options) => options} options={importUsers}
                inputValue={importSearch}
                value={selectedImportUsers}
                getOptionLabel={(option) => `${option.fullName || ""} - ${option.username || ""}`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, values) => {
                  setSelectedImportUsers(values);
                  setImportConfig((config) => ({ ...config, userIds: values.map((value) => value.id) }));
                  setImportSearch("");
                  setImportPage(1);
                  loadImportUsers(1, "");
                }}
                onInputChange={(_, value, reason) => {
                  if (reason === "input" || reason === "clear") {
                    setImportSearch(value);
                    setImportPage(1);
                    loadImportUsers(1, value);
                  }
                }}
                ListboxProps={{
                  style: { maxHeight: 200 },
                  onScroll: (event) => {
                    const list = event.currentTarget;
                    if (importHasMore && list.scrollTop + list.clientHeight >= list.scrollHeight - 8) {
                      const nextPage = importPage + 1;
                      setImportPage(nextPage);
                      loadImportUsers(nextPage, importSearch);
                    }
                  },
                }}
                renderInput={(params) => <TextField {...params} size="small" label="Users to import from" placeholder="Search users" />}
                sx={{ marginTop: "4px" }}
              />
            )}
          </Grid>
          <Grid item sm={12} md={12} style={{ marginTop: "8px" }}>
            <h4 style={{textAlign:"center", margin:"unset"}}>Date Access</h4>
          </Grid>
          <Grid item>
              <InputLabel>Show Invoice</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  width: "200px",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.showInvoice}
                  sx={{
                    "& input": {
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.showInvoice = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {/* {!validated &&
            (formData.showInvoice === null || formData.showInvoice === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )} */}
          </Grid>
          <Grid item>
          <InputLabel>Create Invoice</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  width: "200px",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.createInvoice || null}
                  sx={{
                    "& input": {
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.createInvoice = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {/* {!validated &&
            (formData.createInvoice === null || formData.createInvoice === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )} */}
          </Grid>
          <Grid item>
          <InputLabel>Offer Price</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  width: "200px",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.offerPrice || null}
                  sx={{
                    "& input": {
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.offerPrice = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {/* {!validated &&
            (formData.offerPrice === null || formData.offerPrice === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )} */}
          </Grid>
          <Grid item>
          <InputLabel>Purchase & Supplier</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  width: "200px",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.purchaseSupplierAccess || null}
                  sx={{
                    "& input": {
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.purchaseSupplierAccess = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {/* {!validated &&
            (formData.purchaseSupplierAccess === null || formData.purchaseSupplierAccess === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )} */}
          </Grid>
          <Grid item>
          <InputLabel>Total Calculator</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                sx={{
                  padding: "unset !important",
                  width: "200px",
                }}
                components={["DatePicker"]}
              >
                <DatePicker
                  value={formData.showTotalCalculator || null}
                  sx={{
                    "& input": {
                      padding: "9px !important",
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#41c1ba !important",
                      padding: "9px !important",
                    },
                    "& fieldset": {
                      borderColor: "#41c1ba !important",
                      "& legend": {
                        "& span": {
                          color: "#41c1ba !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#41c1ba !important",
                    },
                  }}
                  onChange={(newValue) => {
                    const dupObj = { ...formData };
                    dupObj.showTotalCalculator = newValue;
                    setFormData(dupObj);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            {/* {!validated &&
            (formData.showTotalCalculator === null || formData.showTotalCalculator === "") && (
              <div style={{ color: "red", fontSize: "small" }}>
                Date is required
              </div>
            )} */}
          </Grid>

          <Grid item xs={12} style={{ marginTop: "8px" }}>
            <FormControl
              size="small"
              sx={{
                width: "100%",
                "& .MuiInputLabel-shrink": { color: "#41c1ba !important" },
                "& fieldset": {
                  borderColor: "#41c1ba !important",
                  "& legend": { "& span": { color: "#41c1ba !important" } },
                },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#41c1ba" },
              }}
            >
              <InputLabel id="zatca-phase-label">{t("ZATCA Phase")}</InputLabel>
              <Select
                labelId="zatca-phase-label"
                id="zatca-phase-select"
                label={t("ZATCA Phase")}
                value={formData.zatca_phase}
                disabled={user !== null && duplicate !== true}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, zatca_phase: Number(e.target.value) }));
                }}
              >
                <MenuItem value={1}>
                  <span>
                    <strong>Phase 1</strong> &nbsp;-&nbsp; Legacy (Simple QR, No ZATCA Reporting)
                  </span>
                </MenuItem>
                <MenuItem value={2}>
                  <span>
                    <strong>Phase 2</strong> &nbsp;-&nbsp; Modern (Full ZATCA XML Signing &amp; Reporting)
                  </span>
                </MenuItem>
              </Select>
            </FormControl>
            <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>
              This cannot be changed after the user is created.
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          variant="contained"
          sx={{
            background: "#365b6d",
            "&:hover": { backgroundColor: "#365b6d" },
          }}
          onClick={handleSubmit}
        >
          {user === null || duplicate === true ? "Add User" : "Update User"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserModal;
